import VueElementLoading from "vue-element-loading";
import Pagination from "./../../../../shared/components/pagination";
import CustomExpandableTable from "../../../../shared/components/customExpandableTable";
import Loader from "../../../../shared/components/loader";
import Multiselect from "vue-multiselect";
import { Validator } from "vee-validate";
import CryptoJS from "crypto-js";
import Treeselect from "@riophae/vue-treeselect";
import CargoBookingServices from "./../../../../cargobooking/services/cargobooking.service";
import CONSTANT from '../../../../shared/constants/constant';
import XLSX from 'xlsx';
const moment = require('moment');
import viewairratetemplate from './../viewairratetemplate'
import Util from './../../../../shared/util/util';


export default {
  name:"viewAirline",
  props: ['selectedCategory'],
  components: {
    VueElementLoading,
    Pagination,
    Loader,
    CustomExpandableTable,
    Multiselect,
    Validator,
    Treeselect,
    viewairratetemplate
  },
  data: function () {
    return {
      tableArr: [],
      isLoading: false,
      Loader: false,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      tableColumn: ["Airline","Effective From","Last Modified Date", "Last Modified By","Version", "Created By",'Action'],
	  innerTableColumn:[],
      tableItems: [],
      airlinesArray:[],
	  airlinesArrayObject: [],
      airlines: null,
	  airlineversion: 'Airline Version',
    dataForView : {},
    businesstype : null
    };
  },
  computed: {},
  async   mounted() {
   await  this.getAirlineList();
	  await this.getAirlineData();
  },
  methods: {
    showRoutelist() {
      this.$emit("goBackToParent")
    },
    async getAirlineList() {
      try {
        let InputPayload = {};
        this.isLoading = true;
        let response = await CargoBookingServices.getAirCargoData(InputPayload);
        if (response.data.code === 200) {
          this.airlinedata = response.data.data.resultairlinename;
          for (var i = 0; i < this.airlinedata.length; i++) {
            this.airlinesArray.push(
			  {
              id: this.airlinedata[i].id,
              airlinename: this.airlinedata[i].airlinename,
              }
			);
          }
        } else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async getAirlineData() {
      try {
        this.isLoading = true;
        try {
          let inputPayload = {
            offset: this.offset,
            limit: this.pageLimit,
            category : this.selectedCategory.id
          };
          if (this.airlines != null) {
            inputPayload.airlineid = this.airlines.id;
			      this.airlineversion = this.airlines.airlinename +' '+'Version'
          }
          let result = await CargoBookingServices.getAirlineData(inputPayload);
          this.isLoading = false;
          if (result.data.code == 200) {
            this.totalCount = result.data.data.count;
            this.tableArr = result.data.data.rows;
            this.tableItems = result.data.data.rows.map((el) => {
              return {
                'id':el.id,
                "Airline":el.airlinename,
				        "Effective From":el.effectivefrom,
				        "Last Modified Date":Util.displayDateOnlyFormat(el.lastmodifieddate),
				         "Last Modified By":el.lastmodifiedby,
				        "Version":1,
				        "Created By":el.createdby,
                'Action' : 'chk'
              };
            });
            if (this.totalCount < this.pageLimit) {
              this.totalPage = 1;
            } else {
              this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
            }
          } else {
            this.tableItems = [];
            this.$alert(result.data.message, "Airlines List", "error");
            this.currentPage = 1;
            this.totalCount = 0;
            this.offset = 0;
          }
        } catch (err) {
          this.isLoading = false;
        }
      } catch (error) {}
    },
	async DownloadAirlineData() {
        this.isLoading = true
        try {
          let inputPayload = {}
          if (this.airlines != null) {
            inputPayload.airlineid = this.airlines.id;
          }  
          let result = await CargoBookingServices.downloadAirlineData(inputPayload);
          this.isLoading = false;
            if(result.data.code == 200){
            let tempdata= result.data.data.rows.map((el)=>{
              return {
				  'Airline':el.airline,
				  'effectivefrom':el.effectivefrom,
				  'lastmodifieddate':el.lastmodifieddate,
				  'lastmodifiedby':el.lastmodifiedby,
				  'version':1,
				  'createdby':el.createdby
              }
            })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,dt+'AirlineData.xlsx');
          }else{
            // tempdata = []
          }
         
        } catch (err) {
          this.isLoading = false;
        }
      },
	clearForm(){
		this.airlines=null
	},
    searchAirline() {
      this.currentPage = 1;
      this.offset = 0;
      this.getAirlineData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit;
      this.getAirlineData();
    },
    clearForm() {
      this.currentPage = 1;
      this.totalCount = 0;
      this.offset = 0;
      this.airlines = null;
      this.getAirlineData();
      this.$validator.reset();
    },
    getCustomTableEvent(event) {
      if (event.actionType == "view") {

				let objForViewData  = this.tableArr.filter(function(Items) {
					return Items.id == event.id;
				  });
				  this.dataForView = objForViewData[0];
          this.businesstype = this.dataForView.businesstype
				
			}
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/AirWalletTemplate/airlineversion/airlineversion.component.js